var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChatOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(.83134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.418 16.844c.046-.171-.057-.409-.155-.58-.03-.052-.063-.101-.099-.149a7.805 7.805 0 0 1-1.289-4.297c-.014-4.385 3.622-7.943 8.118-7.943 3.921 0 7.194 2.717 7.96 6.322.114.535.172 1.08.172 1.627 0 4.391-3.496 8.005-7.992 8.005-.715 0-1.68-.18-2.206-.327a14.835 14.835 0 0 1-1.187-.395 1.215 1.215 0 0 0-.906.014l-2.65.957a.627.627 0 0 1-.182.047.377.377 0 0 1-.374-.38.619.619 0 0 1 .023-.129Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.831.831 18.29 18.29",
    stroke: "currentColor",
    strokeWidth: 1.663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    transform: "translate(2 2)"
  })))));
};
export { SvgChatOff as ReactComponent };